module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"自動投薬機","no_data":"データがありません","invalid_user_id":"mirakun.comのIDが正しく設定されていません","headers":{"name":"名称","ip_address":"IPアドレス","serial_number":"シリアル番号"}},"en":{"title":"Chemical treatment system","no_data":"No data","invalid_user_id":"Your mirakun.com User ID is invalid","headers":{"name":"Name","ip_address":"IP Address","serial_number":"Serial Number"}}}')
  delete Component.options._Ctor
}
